import classNames from "classnames";
import React from "react";

export const ClientReportPortfolio = (props: any) => {
    const cssClassName = classNames("cp-report-panel", props.cssWrapper);

    return (
        <div className={cssClassName}>
            <div className="cp-report-tile">{props.children}</div>
        </div>
    );
};
